import { render, staticRenderFns } from "./LomTrainingQuestionEdit.vue?vue&type=template&id=c3cb516a"
import script from "./LomTrainingQuestionEdit.vue?vue&type=script&lang=js"
export * from "./LomTrainingQuestionEdit.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingQuestionEdit.vue?vue&type=style&index=0&id=c3cb516a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports